import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Geometry, Buffer, TYPES } from '@pixi/core';
var MeshGeometry = /*#__PURE__*/function (_Geometry) {
  _inherits(MeshGeometry, _Geometry);
  var _super = _createSuper(MeshGeometry);
  function MeshGeometry(vertices, uvs, index) {
    var _this;
    _classCallCheck(this, MeshGeometry);
    _this = _super.call(this);
    var verticesBuffer = new Buffer(vertices);
    var uvsBuffer = new Buffer(uvs, true);
    var indexBuffer = new Buffer(index, true, true);
    _this.addAttribute("aVertexPosition", verticesBuffer, 2, false, TYPES.FLOAT).addAttribute("aTextureCoord", uvsBuffer, 2, false, TYPES.FLOAT).addIndex(indexBuffer);
    _this._updateId = -1;
    return _this;
  }
  _createClass(MeshGeometry, [{
    key: "vertexDirtyId",
    get: function get() {
      return this.buffers[0]._updateID;
    }
  }]);
  return MeshGeometry;
}(Geometry);
export { MeshGeometry };